import { Component, Renderer } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { EmailDeliveryService } from './email-delivery.service';

@Component({
  selector: 'email-delivery',
  template: require('./email-delivery.component.html'),
  styles: [require('./email-delivery.component.scss')],
  providers: [EmailDeliveryService]
})
export class EmailDeliveryComponent {

  constructor(private service: EmailDeliveryService, private renderer: Renderer, private route: ActivatedRoute) {
    // Do stuff
  }

  delete($event, schedule: any) {
    this.service.delete($event.target, schedule.id);
  }

  setClass(target, state) {
    this.renderer.setElementClass(target, 'saving', false);
    this.renderer.setElementClass(target, 'saved', false);
    this.renderer.setElementClass(target, 'error', false);
    this.renderer.setElementClass(target, state, true);
  }

  setSchedule(old, $event) {
    this.service.update(old, $event);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/email-delivery/email-delivery.component.ts